
export const Environment = {
    isDevelopment: () => {
        return process.env.NODE_ENV === 'development' || 
               window.location.hostname.includes('replit.dev') ||
               window.location.hostname.includes('replit.co') ||
               window.location.hostname === 'localhost';
    },
    
    isProduction: () => {
        // Если это deployment на replit.app, считаем продакшеном
        if (window.location.hostname.includes('replit.app')) {
            return true;
        }
        
        // Если NODE_ENV явно установлен как production
        if (process.env.NODE_ENV === 'production') {
            return true;
        }
        
        // Если это не dev/co домены и не localhost, скорее всего продакшен
        return !window.location.hostname.includes('replit.dev') &&
               !window.location.hostname.includes('replit.co') &&
               window.location.hostname !== 'localhost' &&
               window.location.hostname !== '127.0.0.1' &&
               !window.location.hostname.includes('0.0.0.0');
    },
    
    isReplit: () => {
        return window.location.hostname.includes('replit.dev') ||
               window.location.hostname.includes('replit.co') ||
               window.location.hostname.includes('replit.app') ||
               !!process.env.IS_REPLIT;
    },
    
    getEnvironment: () => {
        if (Environment.isProduction()) return 'production';
        if (Environment.isReplit()) return 'replit';
        return 'development';
    }
};
